/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzDenyPermissionToUserManagedPermissionsMutationResponse, UsersAuthzDenyPermissionToUserManagedPermissionsPathParams, UsersAuthzDenyPermissionToUserManagedPermissions401, UsersAuthzDenyPermissionToUserManagedPermissions403 } from "../models/UsersAuthzDenyPermissionToUserManagedPermissions";

export function getUsersAuthzDenyPermissionToUserManagedPermissionsUrl(userId: UsersAuthzDenyPermissionToUserManagedPermissionsPathParams["userId"], permission: UsersAuthzDenyPermissionToUserManagedPermissionsPathParams["permission"]) {
  const res = { method: 'POST', url: `/users-authz/v1/users/${userId}/permissions/${permission}/deny` as const }
  return res
}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Deny a permission for a user
 * {@link /users-authz/v1/users/:userId/permissions/:permission/deny}
 */
export async function usersAuthzDenyPermissionToUserManagedPermissions(userId: UsersAuthzDenyPermissionToUserManagedPermissionsPathParams["userId"], permission: UsersAuthzDenyPermissionToUserManagedPermissionsPathParams["permission"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzDenyPermissionToUserManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzDenyPermissionToUserManagedPermissions401 | UsersAuthzDenyPermissionToUserManagedPermissions403>, unknown>({ method : "POST", url : getUsersAuthzDenyPermissionToUserManagedPermissionsUrl(userId, permission).url.toString(), ... requestConfig })
  return res.data
}